<template>
  <a-card class="CommentRecord">
    <a-row type="flex" justify="space-between" align="middle">
      <a-form-model layout="inline">
        <a-form-model-item label="选择管理机构">
          <SelectTree @change="changeOrg" style="width: 250px" :allowClear="false" v-model="search.organizationId" :data="organizationList" />
        </a-form-model-item>
        <a-form-model-item label="选择资源">
          <a-select @change="changeCource" style="width: 250px" :filter-option="filterOption" allowClear showSearch v-model="search.resourceId" placeholder="请选择资源">
            <a-select-option :value="item.id" v-for="item in sourceList" :key="item.id">
              {{ item.name }}{{ item.period ? ` - ${item.period}` : '' }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="选择时间">
          <a-range-picker
            style="width: 260px"
            v-model="times"
            @change="changeRange"
            :disabledDate="disabledDate"
            :show-time="{
              hideDisabledOptions: true,
            }"
            format="YYYY年MM月DD日"
          />
        </a-form-model-item>

        <a-form-model-item>
          <a-button type="primary" @click="getList(1)">查询</a-button>
          <a-button @click="resetSearch" style="margin-left: 8px">重置</a-button>
        </a-form-model-item>
      </a-form-model>
      <a-tooltip>
        <template slot="title">导出 </template>
        <a-icon @click="exportExecl" type="logout" style="font-size: 20px; cursor: pointer" />
      </a-tooltip>
    </a-row>

    <div class="current-select" v-show="selectCourse.id">
      <span> {{ selectCourse.name }}{{ selectCourse.period ? ` - ${selectCourse.period}` : '' }} </span>
      <span> {{ selectCourse.courseType === 1 ? '测评课时' : selectCourse.courseType === 2 ? '训练课时' : selectCourse.courseType === 3 ? '混合课时' : '未知类型' }}</span>
      <span>已使用：{{ selectCourse.usedCount }} 人次</span>
      <span>剩余可用：{{ selectCourse.isLimitCount ? selectCourse.maxCount - selectCourse.usedCount + '人次' : '无限制' }}</span>
    </div>
    <div class="table">
      <a-table :columns="columns" :scroll="{ x: 1300 }" rowKey="id" @change="handleTableChange" :pagination="table.tablePagination" :loading="table.tableLoading" :dataSource="table.tableDataSource">
        <div slot="enabled" slot-scope="text">
          <a-switch v-model="text.enabled" disabled />
        </div>
        <div slot="resourceCount" slot-scope="text" class="count">
          {{ text.resourceCount }}
        </div>
        <div slot="maxResourceCount" slot-scope="text" class="count">
          {{ text.maxResourceCount }}
        </div>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { Course, getResourceLog } from '@/utils/http'
import SelectTree from '@/components/SelectTree'
import * as XLSX from 'xlsx'
import moment from 'moment'
const columns = [
  { title: '子机构名称', dataIndex: 'organizationName', key: 'organizationName' },
  { title: '地址', dataIndex: 'organizationAddr', key: 'organizationAddr', align: 'center' },
  { title: '状态', key: 'enabled', scopedSlots: { customRender: 'enabled' }, width: 120, align: 'center' },
  { title: '创建时间', dataIndex: 'createTime', key: 'createTime', align: 'center' },
  { title: '选中时间内被分配资源', scopedSlots: { customRender: 'resourceCount' }, key: 'resourceCount', align: 'center' },
  { title: '创建以来被分配资源总数', scopedSlots: { customRender: 'maxResourceCount' }, key: 'maxResourceCount', align: 'center' },
  { title: '最新分配时间', key: 'updateTime', dataIndex: 'updateTime', align: 'center' },
]
export default {
  components: { SelectTree },
  name: 'CommentRecord',
  data() {
    return {
      moment,
      times: [],
      search: {},
      columns,
      table: tableRelevant.call(this),
      organizationList: [],
      sourceList: [],
      selectCourse: {},
    }
  },
  created() {
    this.getAllOrg()
  },
  methods: {
    changeCource(e) {
      this.selectCourse = this.sourceList.find((v) => v.id == e) || {}
    },
    resetSearch() {
      this.search = {
        organizationId: this.search.organizationId,
      }
      this.selectCourse = {}
      this.times = []
      this.getList(1)
    },
    async exportExecl() {
      const data = []
      const tableData = await this.getAllList()
      for (let i = 0; i < tableData.length; i++) {
        const item = tableData[i]
        let resName = ''
        if (this.search.resourceId) {
          resName = this.selectCourse.name + (this.selectCourse.period ? '-' + this.selectCourse.period : '')
        } else {
          resName = this.sourceList.map((v) => v.name + (v.period ? '-' + v.period : '')).join('，')
        }
        const dataItem = {
          管理机构: this._orgName,
          资源名称: resName,
        }
        for (let j = 0; j < this.columns.length; j++) {
          const column = this.columns[j]
          const key = column.key
          let val = item[key]
          if (key === 'enabled') {
            val = val ? '启用' : '禁用'
          }
          dataItem[column.title] = val
        }
        data.push(dataItem)
      }

      // 2. 创建一个工作簿对象
      const wb = XLSX.utils.book_new()

      // 3. 将数据转换为工作表
      const ws = XLSX.utils.json_to_sheet(data)
      const colWidths = [{ wpx: 160 }, { wpx: 160 }, { wpx: 160 }, { wpx: 160 }, { wpx: 160 }, { wpx: 160 }, { wpx: 160 }, { wpx: 160 }, { wpx: 160 }]

      // 应用列宽
      ws['!cols'] = colWidths
      // 4. 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

      // 5. 导出为 Excel 文件
      XLSX.writeFile(wb, '数据统计.xlsx')
    },
    changeOrg(e) {
      if (!e) {
        this.sourceList = []
        this.search.resourceId = undefined
        return
      }
      const org = this.organizationList.find((v) => v.id == e) || {}
      this.sourceList = []
      this.selectCourse = {}
      this.search.resourceId = undefined
      this._orgName = org.name
      this.getScource(e)
    },
    getAllOrg() {
      this.$http.Mechanism.getSuperiorTree({ type: 5 }).then((res) => {
        const { data } = res
        this.organizationList = data
        this.search.organizationId = this.organizationList[0]?.id
        this._orgName = this.organizationList[0]?.name
        this.getScource(this.search.organizationId)
        this.getList(1)
      })
    },
    getScource(organizationId) {
      this.$http.CourseService.getCourseResources({
        organizationId,
        pageSize: 999,
        pageIndex: 1,
      }).then((res) => {
        const { data, status, message } = res
        this.sourceList = data.items
      })
    },
    changeRange(e = []) {
      if (e.length === 0) {
        this.search.startTime = undefined
        this.search.endTime = undefined
      } else {
        this.search.startTime = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
        this.search.endTime = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      this.$router.push({
        query: {
          startTime: this.search.startTime,
          endTime: this.search.endTime,
        },
      })
    },
    clearSearch() {
      this.search = {
        contentName: undefined,
        versionName: undefined,
        contentType: undefined,
        minScore: undefined,
        maxScore: undefined,
        orderBy: undefined,
        isDesc: undefined,
      }
      this.getList(1)
    },
    handleTableChange(pagination, filters, sorter) {
      const { order = '', columnKey } = sorter
      const map = {
        ascend: false,
        descend: true,
      }
      console.log(sorter)
      this.search.OrderByDesc = map[order]
      if (typeof columnKey === 'string') {
        this.search.OrderByName = columnKey.slice(0, 1).toUpperCase() + columnKey.slice(1)
      }
      if (map[order] === undefined) {
        this.search.OrderByName = undefined
      }
      console.log(this.search)
      this.getList()
    },
    // 获取列表数据
    getList(pageIndex) {
      let params = {
        pageIndex: pageIndex || this.table.tablePagination.current,
        pageSize: this.table.tablePagination.pageSize,
        ...this.search,
        module: '课程资源',
      }
      this.table.tableLoading = true
      getResourceLog(params).then((res) => {
        const { data } = res
        this.table.tableDataSource = data.items
        this.table.tablePagination.total = data.totalCount
        this.table.tablePagination.current = data.pageIndex
      }).finally(() => {
        this.table.tableLoading = false
      })
    },
    async getAllList() {
      let params = {
        pageIndex: 1,
        pageSize: 9999,
        ...this.search,
        module: '课程资源',
      }
      const { data } = await getResourceLog(params)
      return data.items
    },
    disabledDate(current) {
      return current && current < moment('2019').startOf('day')
    },
    filterOption(input, option) {
      const re = new RegExp(`[${input}]`, 'g')
      const match = option.componentOptions.children[0].text.match(re)
      if (match) {
        return match.length >= input.length
      }
      return false
    },
  },
}
</script>

<style scoped lang="less">
.CommentRecord {
}
.table {
  margin-top: 15px;
}
.current-select {
  margin: 20px 0;
  span {
    margin-right: 24px;
  }
}
.count {
  color: #409eff;
}
</style>
